module.exports = __webpack_public_path__ + "assets/logo-white@3x.c2185233.png";